import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const formatPrice = (n) => `$${Number(n).toLocaleString('en-AU')}`;

export const PackageSelector = ({ packages, selectedPackage, onSelect }) => (
  <Card className="border-2 border-[#8B7355]/20">
    <CardHeader>
      <CardTitle className="font-serif text-2xl text-[#8B7355]">Choose Your Package</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="grid md:grid-cols-3 gap-4">
        {packages.map((pkg) => {
          const isActive = selectedPackage === pkg.slug;
          const cardClass = isActive
            ? 'border-[#C9A961] bg-[#C9A961]/10'
            : 'border-[#8B7355]/20 hover:border-[#8B7355]/40';
          const hasFounding = pkg.regular_price && pkg.regular_price > pkg.price;
          return (
            <div
              key={pkg.slug}
              onClick={() => onSelect(pkg.slug)}
              className={`relative p-6 border-2 rounded-lg cursor-pointer transition-all ${cardClass}`}
              data-testid={`package-${pkg.slug}`}
            >
              {pkg.is_popular && (
                <div className="absolute top-0 right-0 bg-[#8B7355] text-white px-3 py-1 text-xs font-serif">
                  Popular
                </div>
              )}
              <h3 className="font-serif text-lg text-[#8B7355] mb-2">{pkg.name}</h3>
              {hasFounding && (
                <p className="text-xs text-[#8B7355]/60 mb-1">
                  <span className="line-through">{formatPrice(pkg.regular_price)}</span>
                  <span className="ml-2 uppercase tracking-widest text-[#C9A961]">Founding</span>
                </p>
              )}
              <p className="text-2xl font-bold text-[#C9A961]">{formatPrice(pkg.price)}</p>
              {pkg.description && (
                <p className="text-xs text-[#8B7355]/70 mt-2 italic">{pkg.description}</p>
              )}
            </div>
          );
        })}
      </div>
      {packages.length === 0 && (
        <p className="text-[#8B7355]/70 italic">No packages available right now.</p>
      )}
    </CardContent>
  </Card>
);
